import React = require("react");
import {BarChart, BarChartRow} from "../charts/BarChart";
import {VeBoxCard} from "../../../components/card/VeBoxCard";
import {AppTranslations} from "../../../components/Utils/translations/AppTranslations";
import {Display} from "../../../components/Display";
import {EmptyState, infoIcons} from "@vebox/etui-core";
import AutoSizer from "react-virtualized-auto-sizer";

declare var AppTranslations: AppTranslations;

interface HistogramChartWidgetProps {
    title: string;
    yUnitOfMeasure: string;
    data: BarChartRow[];
}

export class HistogramChartWidget extends React.Component<HistogramChartWidgetProps, {}> {
    constructor(props: HistogramChartWidgetProps) {
        super(props);
    }

    public render() {
        return (
            <VeBoxCard className={"marketing-widget marketing-widget-medium no-margin"}>
                <VeBoxCard.Header title={this.props.title}/>
                <VeBoxCard.Body className="marketing-widget__content">
                    <Display isVisible={this.props.data.length === 0}>
                        <EmptyState>
                            <EmptyState.InfoIcon
                                styles={{
                                    root: {
                                        color: "var(--empty-indicator-svg-stroke)",
                                    }
                                }}
                                glyph={infoIcons.NoContent}
                            />
                            <EmptyState.Title color="var(--empty-indicator-title-color)">{AppTranslations.noDataAvailable}</EmptyState.Title>
                            <EmptyState.SubTitle color="var(--empty-indicator-subtitle-color)">{AppTranslations.miscellaneous.checkFiltersMessage}</EmptyState.SubTitle>
                        </EmptyState>
                    </Display>
                    <Display isVisible={this.props.data.length > 0}>
                        <div style={{width: "100%", height: "100%"}}>
                            <AutoSizer style={{width: "auto", height: "auto"}}>
                                {({height, width}) =>
                                    <BarChart
                                        width={width}
                                        height={height}
                                        color={null}
                                        data={this.props.data}
                                        yUnitOfMeasure={this.props.yUnitOfMeasure}
                                    />
                                }
                            </AutoSizer>
                        </div>
                    </Display>
                </VeBoxCard.Body>
            </VeBoxCard>
        );
    }
}
